<div style="position:relative;">
	<ckeditor #myEditor [editor]="Editor" [config]="config" [ngModel]="model.editorData" *ngIf="isLayoutReady" (ready)="onReady($event)" (blur)="saveData($event)" (focus)="selecte()" (change)="change($event)" (click)="resetLib()"/>
	<button *ngIf="ifSrc=='Y'" class="float-btn btn btn-sm btn-outline-light" data-toggle="modal" data-target="#srcModal" (click)='showViewer()'>HTML</button>
</div>
<div *ngIf="ifSrc=='Y'" id="srcModal" #srcModal class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">
	<div class="modal-dialog modal-dialog-centered" style="max-width:40%">
		<div class="modal-content" style="background-color:#cDcDcD">
			<!-- Modal Header  -->
			<div class="modal-header">
				<h6 class="modal-title">Source Editor</h6>
				<button type="button" (click)="closeModal()" data-dismiss="modal" class="close">&times;</button>
			</div>        
			<!-- Modal body -->
			<div class="modal-body">
				<textarea [(ngModel)]="model.editorData" rows="30" class="form-control">	
				</textarea>
			</div>
		</div>
	</div>
</div>
		
	